// Custom add-to-cart for Easify "Order fabric card" buttons
// Expects markup like: <div class="custom-add-to-cart" variant-id="123">Order fabric card</div>

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.custom-add-to-cart');
  if (!btn) return;

  e.preventDefault();

  const variantId = btn.getAttribute('variant-id');
  if (!variantId) return;

  btn.classList.add('loading');

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }]
      })
    });

    if (!res.ok) throw new Error('Add to cart failed');

    // Try to trigger whatever cart system the theme uses
    document.dispatchEvent(new CustomEvent('updateCartD'));   // your old theme event
    document.dispatchEvent(new CustomEvent('cart:refresh'));  // common
    document.dispatchEvent(new CustomEvent('cart:updated'));  // common

    // Optional: try to open cart drawer if the theme has a toggle
    const cartToggle =
      document.querySelector('[data-cart-toggle], cart-drawer-toggle, a[href="/cart"]');
    if (cartToggle) cartToggle.click();

  } catch (err) {
    console.error(err);
    window.location.href = '/cart';
  } finally {
    btn.classList.remove('loading');
  }
});
